import React, { useEffect, useState } from "react";
import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.css"; // Doğru CSS importu
import { Toast, ToastContainer } from 'react-bootstrap'; // Toast bileşeni
import CollegeDatatable from "./CollegeDatatable";
import { getAllData } from "../../../lib/collegelistinfo";
import {
  addData,
  getStudentIdData,
  deleteIdData,
} from "../../../lib/studentcollegeinfo";
import { useAuth } from "../../../usercontext";
//import { useParams } from "react-router-dom";
//import { useParams } from "react-router-dom";

function StudentCollegeList({slug}) {
  const [collegelistinfo, setCollegeListInfo] = useState([]);
  const [prevStudenCollegeList, setStudentCollegeList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [checkedRows, setCheckedRows] = useState({});
  const [activeTab, setActiveTab] = useState("global"); // Aktif sekmeyi belirle
  const [toastMessage, setToastMessage] = useState(""); // Bildirim mesajı
  const [showToast, setShowToast] = useState(false); // Bildirim durumu

  // const { profile } = useAuth();
  //const {id} = useParams()
  
  // const id = profile.id;

  async function GetData() {
    const list = await getAllData(setLoading);
    const list2 = await getStudentIdData(slug);
    setCollegeListInfo(list);
    setStudentCollegeList(list2);
  }

  useEffect(() => {
    GetData();
  }, [activeTab, showToast]);

  const handleUpdate = async () => {
    const newCheckedRows = checkedRows;
    const existingCheckedRows = prevStudenCollegeList.map(
      (college) => college.collegeId
    );

    const toBeAdded = Object.keys(newCheckedRows).filter(
      (id) => newCheckedRows[id] === true && !existingCheckedRows.includes(id)
    );
    const toBeDeletedCoureseIds = Object.keys(newCheckedRows).filter(
      (id) => newCheckedRows[id] === false && !existingCheckedRows.includes(id)
    );

    // Silinecek ID'leri prevStudenCollegeList'ten filtreleme
    const deletedIds = prevStudenCollegeList
      .filter((college) =>
        toBeDeletedCoureseIds.includes(String(college.collegeId))
      )
      .map((college) => college.id);

    try {
      // Yeni işaretli olanları ekle
      if (toBeAdded.length > 0) {
        await addData(
          toBeAdded.map((collegeID) => ({
            collegeId: String(collegeID),
            studentId: slug,
          }))
        );
      }

      // Silinmesi gerekenleri sil
      if (deletedIds.length > 0) {
        await Promise.all(
          deletedIds.map(async (collegeId) => {
            await deleteIdData(collegeId);
          })
        );
      }

      // Başarılı bildirim
      setToastMessage("Data has been updated successfully!");
      setShowToast(true);
      console.log("Data has been updated successfully");
    } catch (error) {
      // Başarısız bildirim
      setToastMessage("Error updating data!");
      setShowToast(true);
      console.error("Error updating data:", error);
    }
  };

  // "My Colleges" için filtrelenen verileri al
  const myColleges = collegelistinfo.filter((college) =>
    prevStudenCollegeList.some((prevCollege) => prevCollege.collegeId === college.id)
  );

  return (
    <div className="App">
      {/* <h1 className="datatable_title">College Table</h1> */}

      {/* Sekme Navigasyonu */}
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "global" ? "active" : ""}`}
            onClick={() => setActiveTab("global")}
            href="#"
          >
          All College
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "my" ? "active" : ""}`}
            onClick={() => setActiveTab("my")}
            href="#"
          >
            My Colleges
          </a>
        </li>
      </ul>

      {/* Sekme İçeriği */}
      <div className="tab-content">
        {activeTab === "global" && (
          <div className="tab-pane fade show active">
            <CollegeDatatable
              prevStudenCollegeList={prevStudenCollegeList}
              data={collegelistinfo}
              loading={loading}
              setCheckedRows={setCheckedRows}
              checkedRows={checkedRows}
            />
          </div>
        )}
        {activeTab === "my" && (
          <div className="tab-pane fade show active">
            <CollegeDatatable
              prevStudenCollegeList={prevStudenCollegeList}
              data={myColleges}
              loading={loading}
              setCheckedRows={setCheckedRows}
              checkedRows={checkedRows}
              selectedTab ={"my"}
            />
          </div>
        )}
      </div>

      <div className="college_list_update_btn_div">
        <button className="college_list_update_btn" onClick={handleUpdate}>
          UPDATE
        </button>
      </div>

      {/* Bildirim (Toast) Bileşeni */}
      <ToastContainer  style={{ top: '1rem', right: '1rem', position:"fixed" }} className="p-3">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Bildirim</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body> {/* Dinamik mesaj */}
        </Toast>
      </ToastContainer>
    </div>
  );
}

export default StudentCollegeList;
